import { FileCheck, Truck, FlaskConical, UserCheck, ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { waWithMessage } from "./data";

const POINTS = [
  { icon: FileCheck, text: "Custom monthly supply contracts tailored to your plant's consumption" },
  { icon: Truck, text: "Fleet logistics network for scheduled, on-time bulk dispatch" },
  { icon: FlaskConical, text: "Lab test certificates available with every consignment" },
  { icon: UserCheck, text: "Dedicated B2B account manager for your orders" },
];

export const BulkSupply = () => (
  <section id="bulk-supply" data-testid="bulk-supply-section" className="relative overflow-hidden bg-[#062A19] py-20 lg:py-32">
    <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-emerald-500/10 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-emerald-500/10 blur-3xl" />
    <div className="container relative mx-auto grid grid-cols-1 items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
      <Reveal>
        <Eyebrow>For Industry</Eyebrow>
        <h2 className="font-display mt-4 text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl" data-testid="bulk-supply-heading">
          Industrial &amp; Bulk Supply
        </h2>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-emerald-100/70 sm:text-lg">
          Running a boiler, kiln or furnace? Lock in a dependable green fuel supply
          with KARM INDUSTRIES — consistent quality, contract pricing and scheduled
          delivery, straight from our Katni plant.
        </p>
        <a
          href={waWithMessage("Hello KARM INDUSTRIES, we are interested in a bulk / monthly supply contract for bio pellets. Please contact us.")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="bulk-supply-cta"
          className="group mt-8 inline-flex items-center gap-2 rounded-full bg-emerald-500 px-8 py-4 text-sm font-bold uppercase tracking-wider text-[#050B07] transition-all duration-300 hover:bg-emerald-400 hover:shadow-[0_0_36px_rgba(16,185,129,0.45)]"
        >
          Discuss Bulk Supply
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </a>
      </Reveal>

      <div className="grid gap-4">
        {POINTS.map((p, i) => (
          <Reveal key={p.text} delay={i * 0.08}>
            <div className="flex items-start gap-4 rounded-2xl border border-emerald-400/20 bg-[#050B07]/50 p-5 backdrop-blur-sm" data-testid={`bulk-point-${i}`}>
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-emerald-500/15 text-emerald-300">
                <p.icon className="h-5 w-5" />
              </div>
              <p className="pt-2 text-sm leading-relaxed text-emerald-50/90 sm:text-base">{p.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
